<template>
<svg viewBox="0 0 14 14" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-cycle-prep`]" width="1em" height="1em" v-bind="$attrs"><path d="M10.304 7.53267C11.5724 7.53267 12.6008 8.56106 12.6008 9.82955C12.6008 11.0981 11.5725 12.1264 10.304 12.1264C9.03565 12.1262 8.00708 11.0979 8.00708 9.82955C8.00711 8.56122 9.03567 7.53292 10.304 7.53267ZM5.04419 7.41353C6.0805 7.22034 5.79767 8.01721 5.79028 8.03756L5.44653 8.8735C6.03465 9.08966 6.5694 9.21598 7.05396 9.27682C7.02358 9.45656 7.0071 9.64117 7.00708 9.82955C7.00715 10.3326 7.12 10.8093 7.32153 11.2358C5.87261 11.3821 4.60176 10.9023 4.5979 10.9008L4.26099 11.7387C4.05633 12.291 3.59295 12.1433 3.42603 11.853L1.7356 8.98678C1.42514 8.40476 2.08321 8.20072 2.09302 8.19771L5.04419 7.41353ZM9.67017 9.41646C9.44227 9.41647 9.25711 9.60166 9.25708 9.82955C9.25708 10.0575 9.44224 10.2426 9.67017 10.2426H10.9387C11.1666 10.2426 11.3518 10.0575 11.3518 9.82955C11.3518 9.60168 11.1666 9.4165 10.9387 9.41646H9.67017ZM8.53931 1.58736C8.75847 1.06774 9.19867 1.17552 9.3772 1.49557L10.9944 4.40279C11.2896 4.9919 10.6317 5.17937 10.6184 5.18307L7.64966 5.89205C6.5973 6.06202 6.91508 5.25492 6.91724 5.24947L7.28247 4.42232C3.4118 2.88891 1.81781 5.26648 1.47974 5.88521L1.40845 6.02584C2.70376 0.207214 8.12957 2.39687 8.18091 2.41744L8.53931 1.58736Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillCyclePrep',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
